/* The function for the accordion menu */
jQuery(document).ready(function(){
// Add a class to the primary menu title bar and menu accordion icon when open
    jQuery(".menu-accordion-menu").click(function(){
        jQuery(this).toggleClass('menu-open'); // add menu-open class to the title-bar when menu is open
        jQuery(".top-accordion-menu").toggleClass('open-accordion-menu');
    });
});